import PropTypes from 'prop-types';
import styles from './DescriptionCard.module.scss';

const DescriptionCard = ({ t, categ }) => (
	<aside className={styles['description-background']} data-test-id="description-background">
		<h2 className={styles['description-title']} data-test-id="description-title">
			<span dangerouslySetInnerHTML={{ __html: categ.name }} /> : {t('category:keyPoints')}
		</h2>
		<div
			className={styles['long-description-modal']}
			data-test-id="long-description-modal"
			dangerouslySetInnerHTML={{ __html: categ.longDescription }}
		/>
	</aside>
);

DescriptionCard.propTypes = {
	t: PropTypes.func.isRequired,
	categ: PropTypes.object.isRequired,
};

export default DescriptionCard;
